/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the patient referral-credit program: referrer codes are minted, referred friends get the referral discount, and referrers are awarded account credit (plus email) when the friend subscribes. Off when absent.
 * @export
 * @interface ReferralProgramModule
 */
export interface ReferralProgramModule {
    /**
     * 
     * @type {boolean}
     * @memberof ReferralProgramModule
     */
    enabled?: boolean;
    /**
     * Dollar amount credited to the referrer when a referred friend subscribes (also shown in patient-facing referral copy). Falls back to the legacy $50 default when absent.
     * @type {number}
     * @memberof ReferralProgramModule
     */
    credit_amount?: number;
}

/**
 * Check if a given object implements the ReferralProgramModule interface.
 */
export function instanceOfReferralProgramModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReferralProgramModuleFromJSON(json: any): ReferralProgramModule {
    return ReferralProgramModuleFromJSONTyped(json, false);
}

export function ReferralProgramModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralProgramModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'credit_amount': !exists(json, 'credit_amount') ? undefined : json['credit_amount'],
    };
}

export function ReferralProgramModuleToJSON(value?: ReferralProgramModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'credit_amount': value.credit_amount,
    };
}

